var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tabs"},[_c('button',{class:[
      'tabs__nav-button',
      'tabs__nav-button_prev',
      { 'tabs__nav-button_disabled': !_vm.haveScrollLeft }
    ],on:{"click":_vm.selectPrev}},[_c('ChevronIcon',{staticClass:"tabs__nav-button-icon"})],1),_c('div',{staticClass:"tabs__slider-wrapper"},[_c('Flickity',{key:`tabs-slider-${_vm._uid}`,ref:"flickity",class:[
        'tabs__slider',
        {'tabs__slider_have-scroll-right': _vm.showRightGradient},
        {'tabs__slider_have-scroll-left': _vm.showLeftGradient}
      ],attrs:{"options":_vm.sliderOptions}},_vm._l((_vm.tabs),function(tab){return _c('button',{key:`tab-${tab.value}`,class:[
          'tabs__tab',
          {'tabs__tab_active': _vm.activeTabValue === tab.value}
        ],on:{"click":function($event){return _vm.selectTab(tab.value)}}},[_vm._v("\n        "+_vm._s(tab.text)+"\n      ")])}),0)],1),_c('button',{class:[
      'tabs__nav-button',
      'tabs__nav-button_next',
      { 'tabs__nav-button_disabled': !_vm.haveScrollRight }
    ],on:{"click":_vm.selectNext}},[_c('ChevronIcon',{staticClass:"tabs__nav-button-icon"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }